import { objToQs } from "../Utils";

import Call from '../Call.v2';

const AdkBids = {
    get(filters) {
        return Call(`adk/unblocked?${objToQs(filters)}`);
    }
};

export default AdkBids;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkUnblocked.js